import request from './base'

export const mapList = (params) => {
    return request.post("/admin/v1/map/list", params)
}

export const mapInfo = (params) => {
    return request.post("/admin/v1/map/info", params)
}

export const mapAdd = (params) => {
    return request.post("/admin/v1/map/add", params)
}


export const mapDelete = (params) => {
    return request.post("/admin/v1/map/delete", params)
}

export const mapModify = (params) => {
    return request.post("/admin/v1/map/modify", params)
}

export const mapUpload = (params) => {
    return request.post("/admin/v1/map/upload", params)
}

export const mapPoiAdd = (params) => {
    return request.post("/admin/v1/map/poi/add", params)
}

export const mapPoiModify = (params) => {
    return request.post("/admin/v1/map/poi/modify", params)
}

export const mapPoiDelete = (params) => {
    return request.post("/admin/v1/map/poi/delete", params)
}

export const mapPoiLine = (params) => {
    return request.post("/admin/v1/map/poi/line", params)
}

export const getMapInfo = (params) => {
    return request.post("/admin/v1/map/info", params)
}

export const getMapCarList = (params) => {
    return request.post("/admin/v1/map/car/list", params)
}

export const mapPush = (params) => {
    return request.post("/admin/v1/map/push", params)
}

export const mapPushLogs = (params) => {
    return request.post("/admin/v1/map/pushLogs", params)
}

export const mapCreateImage = (params) => {
    return request.post("/admin/v1/map/createMapImage", params)
}

export const getRegionInfo = (params) => {
    return request.post("/admin/v1/map/getRegionInfo", params)
}




// WEBPACK FOOTER //
// ./src/api/map.js